<script lang="ts" setup>
import { ref, watch } from 'vue';
import type { RecommendItem } from '@/utils/type';
import Content from './components/Content/Content.vue';
import { queryList, resetState } from '@/tools/queryFreshFinds';
import Skeleton from './components/Skeleton/Skeleton.vue';
// import { useRouter } from 'vue-router';

const props = defineProps<{
    // 组件配置
    contentConfig: {
        defaultExpand: boolean;
        abstractRow: number;
    };
    // 分类 ID
    categoryId: string;
}>();

// const router = useRouter();

// 相关推荐数据
const recommendationList = ref<RecommendItem[]>([]);

// 相关推荐数据初始化是否失败
const initError = ref(false);

// 相关推荐数据是否正在初始化
const initLoading = ref(true);

// 请求 ID, 用于识别最新请求
let requestId = 0;

// 初始化相关推荐数据
const init = async () => {
    // 递增请求 ID
    const currentRequestId = ++requestId;

    initLoading.value = true;
    initError.value = false;
    const feedsList = await queryList({
        contentTextSwitch: true,
        categoryId: props.categoryId,
    });

    // 只处理最新请求的结果
    if (currentRequestId !== requestId) return;

    initLoading.value = false;

    if (feedsList.length === 0) {
        initError.value = true;
        // router.push({ name: 'Error', params: { type: 'load-failed' } });
        return;
    }

    recommendationList.value = feedsList;
};

// 监听 categoryId 变化, 重置状态并重新加载
watch(
    () => props.categoryId,
    () => {
        resetState();
        init();
    },
);

init();
</script>

<template>
    <div v-if="!initError" class="card_recommendation">
        <Skeleton v-if="initLoading" />

        <!-- 正确加载正文数据和相关推荐数据, 则渲染 Content 组件 -->
        <Content
            v-else
            v-model:recommendationList="recommendationList"
            :contentConfig="contentConfig"
            :categoryId="categoryId"
        />
    </div>
</template>

<style lang="scss" scoped>
@use './CardRecommendation.scss';
</style>
